// Components==============
import Modal from 'components/UI/Modal';
import RichText from 'components/UI/RichText';
import React from 'react';
import { encodeURL } from 'utilities/encodeURL';
import './index.module.scss';
// =========================

export default function CardModal({ title, description, image, richText }) {
    return (
        <Modal
            slug={`card-popup/${encodeURL(title)}`}
            image={image}
            imageText={title}
        >
            <div styleName="wrapper">
                {description && <p styleName="description">{description}</p>}
                <RichText richText={richText} />
            </div>
        </Modal>
    );
}
